<template>
	<div class="search-box" v-if="withFilter">
		<SvgIcon class="search-box__ico color-ming" iconName="ico-search"/>
		<input v-if="catName" class="search-box__input" type="search" v-model="searchQuery" @keyup="search" :placeholder="catName">
	</div>
	<div class="container" v-else>
		<div class="search-box">
			<SvgIcon class="search-box__ico color-ming" iconName="ico-search"/>
			<input class="search-box__input js-search-box__input" data-type="package" type="search" v-model="searchQuery" placeholder="Start searching here">
		</div>
	</div>
</template>

<script>
import SvgIcon from '../base/SvgIcon/SvgIcon.vue';
// import axios from 'axios';
export default {
	components: {
		SvgIcon
	},
	props: {
		withFilter: Boolean,
		type: String,
	},
	methods: {
		search: function() {
			if (this.searchQuery.length > 2 || this.searchQuery.length === 0) {
				const data = {
					type: this.type,
					text: this.searchQuery,
					cat: this.getSearchCat.catID,
					dish: this.getFilterDish,
					event: this.getFilterEvent,
					people: this.getFilterPeople,
					price: this.getFilterPrice,
					category: this.category,

				};

				this.$store.dispatch('setSearchText', this.searchQuery);
				this.$store.dispatch('setSearchProducts', data);
			}
		},
	},
	computed: {
		products() {
			return this.$store.getters.getSearchProducts;
		},
		getSearchText() {
			return this.$store.getters.getSearchText;
		},
		getSearchCat() {
			return this.$store.getters.getSearchCat;
		},
		getFilterDish() {
			return this.$store.getters.getChosenFilterDishType;
		},
		getFilterEvent() {
			return this.$store.getters.getChosenFilterEventType;
		},
		getFilterPeople() {
			return this.$store.getters.getChosenFilterPeople;
		},
		getFilterPrice() {
			return this.$store.getters.getChosenFilterPrice;
		}
	},
	data() {
		return {
			searchQuery: '',
			// eslint-disable-next-line no-undef
			category: productsCategory,
			// eslint-disable-next-line no-undef
			catName: catName ? catName : '',
		};

	}
};
</script>

<style lang="scss" scoped>
.search-box {
	position: relative;
}

.search-box__input {
	box-sizing: border-box;
	display: block;
	width: 100%;
	background-color: $white;
	height: 80px;
	padding-left: 104px;
	border: 0;
	outline: 0;
	box-shadow: 5px 8px 29px rgba($black, 0.03);
	border-radius: 10px;
	font-family: $font-second;
	font-size: 18px;
	font-weight: 400;
	color: $happy-blue;
	padding-bottom: 2px;

	&::placeholder {
		color: inherit;
	}

	&:valid,
	&:invalid {
		background: $white;
	}

	@include mq($md) {
		padding: 0 30px 0 40px;
	}
}

.search-box__ico {
	position: absolute;
	font-size: 18px;
	height: 18px;
	top: 50%;
	left: 73px;
	transform: translateY(-50%);
	@include mq($md) {
		left: 10px;
	}
}
</style>
